import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Templates deprecated — redirect staff to the Ops center
const TemplateLibraryPage: React.FC = () => {
  const { isAuthenticated, user } = useAuth();
  const canAccess = !!user?.permissions?.includes('manage_templates');

  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (!canAccess) return <Navigate to="/access-denied" replace />;

  return <Navigate to="/staff/ops-center" replace />;
};

export default TemplateLibraryPage;